export default "__VITE_ASSET__B94dtlay__"